<template>
  <v-app>
    <v-main class="login-wrapper">
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card elevation="12">
              <v-toolbar color="primary" dark>
                <v-toolbar-title>Acceso Death Star</v-toolbar-title>
              </v-toolbar>

              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    v-model="usuario"
                  />
                  <v-text-field
                    label="Password"
                    type="password"
                    v-model="pass"
                  />
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="comprobar">
                  Login
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      usuario: '',
      pass: ''
    }
  },
  methods: {
    comprobar () {
      if (this.usuario === 'deathstar' && this.pass === 'admsportsgroup') {
        this.$router.push({ name: 'Main' })
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<!-- OLD
 <template>
   <v-app id="inspire">
      <v-content>
         <v-container fluid fill-height>
            <v-layout align-center justify-center>
               <v-flex xs12 sm8 md4>
                  <v-card class="elevation-12">
                     <v-toolbar dark color="primary">
                        <v-toolbar-title>Acceso Death Star</v-toolbar-title>
                     </v-toolbar>
                     <v-card-text>
                        <v-form>
                           <v-text-field
                              name="login"
                              label="Login"
                              type="text"
                              v-model="usuario"
                           ></v-text-field>
                           <v-text-field
                              id="password"
                              name="password"
                              label="Password"
                              type="password"
                              v-model="pass"
                           ></v-text-field>
                        </v-form>
                     </v-card-text>
                     <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="comprobar">Login</v-btn>
                     </v-card-actions>
                  </v-card>
               </v-flex>
            </v-layout>
         </v-container>
      </v-content>
   </v-app>
</template>

<script>
export default {
   name: 'Login',
   props: {
      source: String,

   },
   data: () => ({
      usuario:'',
      pass:'',
    }),
     methods: {
         comprobar(){
             if(this.usuario=="deathstar" && this.pass=="admsportsgroup"){
                this.$router.push({ name: "Main"})
             }
         }
     }
};
</script>

<style></style>
-->
